import { render } from "./GestionAccesView.vue?vue&type=template&id=b50cb444"
import script from "./GestionAccesView.vue?vue&type=script&lang=js"
export * from "./GestionAccesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__